import { BASE_URL, DEFAULT_HEADERS } from '@constants';
import axios from 'axios';
import { getStorageItem } from 'helpers';

const axiosInstance = axios.create({
    baseURL: BASE_URL,
});

export const HttpService = ({ url, body = {}, method = 'GET', headers = {}, params = {} }) => {
    const config = {
        method,
        url,
        data: body,
        params,
    };

    config.headers = {
        ...DEFAULT_HEADERS,
        ...headers,
    };

    return axiosInstance(config);
};

axiosInstance.interceptors.request.use(
    config => {
        const accessToken = getStorageItem('access_token');

        if (accessToken) {
            config.headers['Authorization'] = `Bearer ${accessToken}`;
        }

        return config;
    },
    error => {
        void Promise.reject(error);
    },
);

axiosInstance.interceptors.response.use(
    response => {
        return response;
    },
    async error => {
        if (error.response) {
            error.data = error.response.status === 500 ? { message: 'Something went wrong, please try again.' } : error.response.data;
        } else {
            error.data = {
                message: 'Something went wrong, please try again.',
            };
        }

        return Promise.reject(error.response);
    },
);
